import { UnsavedChangesDialog } from '@mews-commander/ui';
import { FloatingPanel } from '@mews/b2b-ui';
import { LocalizedText, useDialog } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { NewPlatformProfileForm } from './NewPlatformProfileForm';
import { useNewPlatformProfileForm } from './useNewPlatformProfileForm';

export const NewPlatformProfileDialog: React.FC<{ closeDialog: () => void }> = ({ closeDialog }) => {
    const { hasDirtyFields, renderFormContent, isSubmitting, submit } = useNewPlatformProfileForm({
        onClose: closeDialog,
    });
    const [unsavedChangesDialogProps, toggleUnsavedDialog] = useDialog();
    const handleClose = hasDirtyFields ? toggleUnsavedDialog : closeDialog;

    return (
        <>
            <FloatingPanel
                active
                footer={{
                    primary: (
                        <Button onClick={submit} size="medium" variant="primary" loading={isSubmitting} type="submit">
                            <LocalizedText textKey={TextKey.SendInvite} />
                        </Button>
                    ),
                    secondary: (
                        <Button onClick={handleClose} size="medium" variant="tertiary" type="submit">
                            <LocalizedText textKey={TextKey.Cancel} />
                        </Button>
                    ),
                }}
                loading={isSubmitting}
                onClose={handleClose}
                title={<LocalizedText textKey={TextKey.InviteNewPlatformProfile} />}
            >
                {renderFormContent(<NewPlatformProfileForm />)}
            </FloatingPanel>
            <UnsavedChangesDialog
                active={unsavedChangesDialogProps.active}
                onCancel={toggleUnsavedDialog}
                onDiscardChanges={closeDialog}
            />
        </>
    );
};
